import { render, staticRenderFns } from "./AtomLogoPrimary.vue?vue&type=template&id=4b7b6162"
import script from "./AtomLogoPrimary.vue?vue&type=script&lang=js"
export * from "./AtomLogoPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports